// Auto-generated by scripts/write-git-version.mjs
export const gitVersion = {
  "sha": "d7f8314dfcc20432f7a6f7b778e63d9c8bec0364",
  "branch": "main",
  "dirty": true,
  "buildTime": "2026-10-16T07:06:53.891Z"
};
export default gitVersion;
